import { Icon, Text, zIndexes } from "@huub-web/ui";

import type { HotspotRecord } from "../../MapboxMapView";

export type GetMainHotspotParams = {
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Address of the property
   */
  address: string;
  /**
   * Name of the neighbourhood (shown as subtitle when not loading)
   */
  name?: string;
  /**
   * Center coordinates [latitude, longitude]
   */
  center: [number, number];
  /**
   * Whether the component is loading
   */
  loading?: boolean;
  /**
   * Translated loading label
   */
  loadingLabel: string;
  /**
   * Z-index for layering (higher = on top). Default: 100
   */
  zIndex?: number;
  /**
   * If true, shows a close button on the tooltip card
   */
  closable?: boolean;
  /**
   * If true, forces tooltip visible and marks as active state
   */
  active?: boolean;
};

/**
 * Creates a hotspot record for the main property location
 * @param params - Configuration parameters for the main hotspot
 * @returns HotspotRecord for the main property marker
 */
export const getMainHotspot = ({
  id,
  address,
  name,
  center,
  loading,
  loadingLabel,
  zIndex = zIndexes.mapMainMarker,
  closable = true,
  active,
}: GetMainHotspotParams): HotspotRecord => ({
  id,
  type: "dot",
  lat: center[0],
  lng: center[1],
  title: loading ? address : name ? address : undefined,
  subtitle: loading ? (
    <Text italic color="currentColor50" variant="bodyS" noWrap>
      {loadingLabel}
    </Text>
  ) : name ? (
    name
  ) : undefined,
  icon: loading ? (
    <Icon icon="loading" size="s2" animation="rotation" />
  ) : name ? (
    "homeFilled"
  ) : undefined,
  indicatorVariant: "gradient",
  noClustering: true,
  zIndex,
  closable,
  active,
});
